export default __webpack_public_path__ + "static/media/category4.37578ba8.png";